export default __webpack_public_path__ + "static/media/globe.1cb45911.svg";